import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createZone, updateZone, deleteZone, ZoneForm } from '@/app/Sites/zonesApi';

interface UseZoneOptions {
  projectId: string;
  companyId: string;
}

export const useCreateZone = ({ projectId, companyId }: UseZoneOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (form: ZoneForm) => createZone(projectId, form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['site', projectId, companyId],
        refetchType: 'all',
      });
    },
  });
};

export const useUpdateZone = ({ projectId, companyId }: UseZoneOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ zoneId, form }: { zoneId: string; form: ZoneForm }) =>
      updateZone(projectId, zoneId, form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['site', projectId, companyId],
        refetchType: 'all',
      });
    },
  });
};

export const useDeleteZone = ({ projectId, companyId }: UseZoneOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (zoneId: string) => deleteZone(projectId, zoneId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['site', projectId, companyId],
        refetchType: 'all',
      });
    },
  });
};
